import { staticLib } from "@public/js/static-lib.js";
import { Directive } from "vue";

type AppHeaderBtnElement = HTMLElement & { _appHeaderBtnDisposer: () => void };

export const appHeaderBtnDirective: Directive<AppHeaderBtnElement> = {
    mounted(el) {
        // TODO - на js анимация чуть плавнее, но я не смог переделать чтобы после смены
        //  языка скрипты вызывались заново, поэтому изменил селекторы, надо либо выпились
        //  данную директиву, либо исправить чтобы она вызывалась после смены языка
        const headerLetters = el.querySelectorAll(".visible-on-hover2");

        staticLib.sliceToLetters(headerLetters);

        const letters = el.querySelectorAll(".letter2");

        staticLib.gsap.set(letters, {
            opacity: 0,
            scale: 0,
            width: 0,
            display: "inline-block",
        });

        const hoverEffect = staticLib.gsap.to(letters, {
            duration: 0.15,
            opacity: 1,
            scale: 1,
            paused: true,
            stagger: 0.05,
            width: "auto",
            ease: "elastic.out.config(1,1)",
        });

        const play = () => {
            hoverEffect.play();
        };

        const reverse = () => {
            hoverEffect.reverse();
        };

        el.addEventListener("mouseenter", play);
        el.addEventListener("mouseleave", reverse);

        el._appHeaderBtnDisposer = () => {
            el.removeEventListener("mouseenter", play);
            el.removeEventListener("mouseleave", reverse);
        };
    },
    unmounted(el) {
        el._appHeaderBtnDisposer();
    },
};
